import React from "react";

const SRCSET =
  "/hero-rail-768.webp 768w, /hero-rail-1280.webp 1280w, /hero-rail-1920.webp 1920w";

export default function HeroBackdrop({ priority = true, alt = "" }) {
  return (
    <img
      src="/hero-rail-1280.webp"
      srcSet={SRCSET}
      sizes="100vw"
      alt={alt}
      aria-hidden={alt === "" ? "true" : undefined}
      width="1920"
      height="1156"
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={priority ? "high" : undefined}
      className="absolute inset-0 h-full w-full object-cover object-center opacity-40"
    />
  );
}
